import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  categoryApi,
  subCategoryApi,
  addSubCategoryApi,
  updateSubCategoryApi,
  deleteCategoryApi,
} from "store/api";

import { Button, IconButton, TextField, Tooltip } from "@mui/material";
import { Add, EditRounded, Search } from "@mui/icons-material";

import Card from "@mui/material/Card";
import UpdateCategory from "../UpdateCategory";
import AddCategory from "../AddCategory";
import axios from "axios";
import Success from "components/Success";
import Stack from "@mui/material/Stack";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useNavigate, useSearchParams } from "react-router-dom";

function TabPanel (props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps (index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function CategoryTab () {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [msg, setMsg] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [openUpdate, setOpenUpdate] = React.useState(false);
  const [openAdd, setOpenAdd] = React.useState(false);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [category, setCategory] = React.useState([]);
  const [subCategory, setSubCategory] = React.useState([]);
  const [updateCategory, setUpdateCategory] = React.useState({
    categories: [
      {
        categoryId: id,
        isActive: true,
      },
    ],
  });
  const [addCategoryImage, setAddCategoryImage] = React.useState({});
  const [updateCategoryImage, setUpdateCategoryImage] = React.useState({});
  const [addCategory, setAddCategory] = React.useState({
    name: "",
    slug: "",
    image: "",
    isActive: "",
    categoryIds: [id],
  });
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handleClickOpenUpdate = data => {
    setUpdateCategory(prev => ({
      ...prev,
      ...data,
    }));
    setOpenUpdate(true);
  };
  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };

  const handleCloseUpdate = () => {
    setOpenUpdate(false);
    //   setOpen(true);
  };
  const handleCloseAdd = () => {
    setOpenAdd(false);
    //   setOpen(true);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const FetchSubCategory = async searchTerm => {
    const params = !searchTerm
      ? { categoryId: id }
      : {
          searchKeyword: searchTerm,
          categoryId: id,
        };
    try {
      const response = await subCategoryApi(params);
      if (response?.success) {
        setSubCategory(response?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const FetchCategory = async searchTerm => {
    const params = !searchTerm
      ? {}
      : {
          searchKeyword: searchTerm,
        };
    try {
      const response = await categoryApi(params);
      if (response?.success) {
        setCategory(response?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const [debounceTimeout, setDebounceTimeout] = React.useState(null);
  const handleChangeCategory = async e => {
    const { value } = e.target;
    // Clear the previous timeout
    if (debounceTimeout) clearTimeout(debounceTimeout);
    // Set a new timeout
    const newTimeout = setTimeout(() => {
      FetchSubCategory(value);
    }, 500); // Adjust debounce delay (500ms)

    setDebounceTimeout(newTimeout);
  };

  const handleSubmitUpdate = async e => {
    e?.preventDefault();
    // delete updateCategory.image;
    const response = await updateSubCategoryApi(updateCategory);
    if (response?.success) {
      let uploadUrl = response?.data?.uploadUrl;
      const uploadResponse = await axios.put(uploadUrl, updateCategoryImage?.image, {
        headers: { "Content-Type": updateCategoryImage?.image?.type },
      });
      if (uploadResponse?.status) {
        setMsg("Update Category Successfully");
        setSuccess(true);
        FetchSubCategory();
        setOpenUpdate(false);
        setOpen(true);
        setUpdateCategoryImage({});
        FetchSubCategory();
      } else {
        setOpen(true);
        setOpenAdd(false);
        setSuccess(false);
        setMsg("Something went wrong in upload image. Please try again later.");
      }
    } else {
      setOpen(true);
      setOpenAdd(false);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
  };
  const handleSubmitAdd = async e => {
    e?.preventDefault();
    // addCategory.categoryOrder = 1;
    const response = await addSubCategoryApi(addCategory);
    if (response?.success) {
      let uploadUrl = response?.data?.uploadUrl;
      const uploadResponse = await axios.put(uploadUrl, addCategoryImage?.image, {
        headers: { "Content-Type": addCategoryImage?.image?.type },
      });
      if (uploadResponse?.status) {
        setMsg("Add Category Successfully");
        setSuccess(true);
        FetchSubCategory();
        setOpenAdd(false);
        setOpen(true);
      } else {
        setOpen(true);
        setOpenAdd(false);
        setSuccess(false);
        setMsg("Something went wrong on image upload. Please try again later.");
      }
    } else {
      setOpen(true);
      setOpenAdd(false);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
  };
  const handleChangeUpdateCategory = e => {
    const { name, value } = e.target;

    // 🚫 Do nothing if categoryId is empty
    if (name === "categories" && !value) return;

    setUpdateCategory(prev => {
      if (name !== "categories") {
        return {
          ...prev,
          [name]: value,
        };
      }

      const existingCategories = prev?.categories || [];

      // 🔍 Check if category already exists
      const existingIndex = existingCategories.findIndex(cat => cat.categoryId === value);

      let updatedCategories;

      if (existingIndex !== -1) {
        // ✅ Toggle isActive for existing category
        updatedCategories = [...existingCategories];
        updatedCategories[existingIndex].isActive = !updatedCategories[existingIndex].isActive;
      } else {
        // ➕ Add new category
        updatedCategories = [
          ...existingCategories,
          {
            categoryId: value,
            isActive: true,
          },
        ];
      }

      return {
        ...prev,
        categories: updatedCategories,
      };
    });
  };

  const handleChangeAddCategory = e => {
    const { name, value } = e.target;
    setAddCategory(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeAddCategoryImage = e => {
    const { name, value } = e.target;
    setAddCategoryImage({
      [name]: e.currentTarget?.files[0],
    });
  };
  const handleChangeUpdateCategoryImage = e => {
    const { name, value } = e.target;
    setUpdateCategoryImage({
      [name]: e.currentTarget?.files[0],
    });
  };

  const DeleteCategory = async categoryId => {
    const params = {
      categoryId: categoryId,
    };
    const response = await deleteCategoryApi(params);
    if (response?.success) {
      setMsg("Delete Category Successfully");
      setSuccess(true);
      FetchCategory();
      setOpenAdd(false);
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpen(true);
  };

  React.useEffect(() => {
    FetchCategory();
    FetchSubCategory();
  }, []);

  return (
    <div
      style={{
        padding: "20px",
        marginTop: "20px",
        marginBottom: "30px",
        backgroundColor: "",
        border: "",
        borderRadius: "12px",
        boxShadow: "0 0 8px 1px rgba(0,0,0,0.25)",
        color: "",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant='h5'>Sub Category</Typography>
        <Button
          variant='contained'
          startIcon={<Add />}
          color='success'
          onClick={() => handleClickOpenAdd()}
          //   style={{ backgroundColor: "", color: "white", textTransform: "none" }}
        >
          Add New
        </Button>
      </div>

      {/* Search and Rows Per Page */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "20px",
        }}
      >
        <TextField
          placeholder='Search here...'
          InputProps={{
            endAdornment: (
              <IconButton color='inherit'>
                <Search />
              </IconButton>
            ),
          }}
          onChange={handleChangeCategory}
          style={{ backgroundColor: "", borderRadius: "4px" }}
        />
      </div>

      <Box>
        <AppBar position='static'>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor='secondary'
            textColor='inherit'
            variant='fullWidth'
            aria-label='full width tabs example'
          >
            <Tab label='All Sub Category' {...a11yProps(0)} />
            <Tab label='Active Sub Category' {...a11yProps(1)} />
            <Tab label='Disable Sub Category' {...a11yProps(2)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {subCategory?.length == 0 && <div>No Sub Category found</div>}
            {subCategory?.length > 0 &&
              subCategory?.map(e => (
                <Category
                  category={e}
                  DeleteCategory={DeleteCategory}
                  handleClickOpenUpdate={handleClickOpenUpdate}
                />
              ))}
          </Grid2>
        </TabPanel>

        <TabPanel value={value} index={1} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {subCategory?.length == 0 && <div>No Sub Category found</div>}
            {subCategory?.length > 0 &&
              subCategory?.map(
                e =>
                  e.isActive && (
                    <Category
                      category={e}
                      DeleteCategory={DeleteCategory}
                      handleClickOpenUpdate={handleClickOpenUpdate}
                    />
                  )
              )}
          </Grid2>
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {subCategory?.length == 0 && <div>No Sub Category found</div>}
            {subCategory?.length > 0 &&
              subCategory?.map(
                e =>
                  !e.isActive && (
                    <Category
                      category={e}
                      DeleteCategory={DeleteCategory}
                      handleClickOpenUpdate={handleClickOpenUpdate}
                    />
                  )
              )}
          </Grid2>
        </TabPanel>
      </Box>
      <UpdateCategory
        open={openUpdate}
        category={category}
        handleClose={handleCloseUpdate}
        handleSubmit={handleSubmitUpdate}
        updateCategoryData={updateCategory}
        updateCategoryImage={updateCategoryImage}
        handleChangeUpdateCategory={handleChangeUpdateCategory}
        handleChangeUpdateCategoryImage={handleChangeUpdateCategoryImage}
      />
      <AddCategory
        open={openAdd}
        handleClose={handleCloseAdd}
        addCategoryData={addCategory}
        handleSubmit={handleSubmitAdd}
        addCategoryImage={addCategoryImage}
        handleChangeAddCategory={handleChangeAddCategory}
        handleChangeAddCategoryImage={handleChangeAddCategoryImage}
      />
      <Success open={open} success={success} msg={msg} handleClose={handleClose} />
    </div>
  );
}

const Category = ({ category, DeleteCategory, handleClickOpenUpdate }) => {
  const navigate = useNavigate();
  return (
    <Grid2 xs={12} sm={6} md={3} style={{ border: "16px", overflow: "hidden" }}>
      <Card>
        <Box sx={{ pt: "100%", position: "relative" }}>
          <div
            style={{
              zIndex: 9,
              top: 10,
              right: 10,
              position: "absolute",
              textTransform: "uppercase",
              display: "flex",
              gap: "10px",
            }}
          >
            {/* <Tooltip title={"Delete"} onClick={() => DeleteCategory(category?.categoryId)}>
              <DeleteRounded style={{ fontSize: "16px", fill: "black", cursor: "pointer" }} />
            </Tooltip> */}
            <Tooltip title={"Edit"} onClick={() => handleClickOpenUpdate(category)}>
              <EditRounded style={{ fontSize: "16px", fill: "black", cursor: "pointer" }} />
            </Tooltip>
          </div>
          <Box
            component='img'
            alt='sub-category'
            src={category?.image}
            sx={{
              top: 0,
              width: 1,
              height: 1,
              zIndex: 0,
              objectFit: "cover",
              position: "absolute",
              borderRadius: "16px 16px 0 0",
            }}
          />
        </Box>

        <Stack spacing={2} sx={{ py: 1, px: 2 }}>
          <Box
            color='inherit'
            underline='hover'
            variant='subtitle2'
            style={{ fontSize: "0.875rem", fontWeight: "500", cursor: "pointer" }}
            noWrap
            onClick={() => navigate(`/sub-category-products?id=${category.subCategoryId}`)}
          >
            <div style={{ fontSize: "20px" }}>{category?.name}</div>
            <div>Slug: {category?.slug}</div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                fontSize: "0.875rem",
              }}
            >
              <div>Active: {category.isActive ? "🟢" : "🔴"}</div>
            </div>
          </Box>
        </Stack>
      </Card>
    </Grid2>
  );
};
